import React, {Fragment, useEffect, useState} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {ContentHeader, Loader} from '@components';
import {logoutUser} from '@app/store/reducers/auth';
import {toast} from 'react-toastify';
import {getUserById} from '../../services/user';
import handleStatus from '../../utils/ajax';

const ViewUser = () => {
  // save selected user data to state
  const [selectedUserData, setSelectedUserData] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const {id} = params;

  const viewUserById = async () => {
    setShowLoader(true);
    const response = await getUserById(id);

    handleStatus(response.status, () => dispatch(logoutUser()), navigate);
    if (!response?.data?.ok) {
      toast.error(response?.data?.message || 'Error while getting user by id');
      return;
    }

    if (response.data.ok === true) {
      setShowLoader(false);
      if (response.data.data) {
        setSelectedUserData(response.data.data);
      }
    }
  };
  useEffect(() => {
    viewUserById();
  }, []);

  if (selectedUserData.gender === '' || selectedUserData.gender === undefined) {
    selectedUserData.gender = 'N/A';
  }

  if (selectedUserData.mobile === '' || selectedUserData.mobile === undefined) {
    selectedUserData.mobile = 'N/A';
  }

  if (selectedUserData.dob === '' || selectedUserData.dob === undefined) {
    selectedUserData.dob = 'N/A';
  }

  if (
    selectedUserData.designation === '' ||
    selectedUserData.designation === undefined
  ) {
    selectedUserData.designation = 'N/A';
  }

  if (
    selectedUserData.address === '' ||
    selectedUserData.address === undefined
  ) {
    selectedUserData.address = 'N/A';
  }

  if (
    selectedUserData.emergencyContact === '' ||
    selectedUserData.emergencyContact === undefined
  ) {
    selectedUserData.emergencyContact = 'N/A';
  }

  if (showLoader) {
    return <Loader title="Daily" />;
  }

  return (
    <>
      <ContentHeader title="View User" path="/all-users" />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">All about User</h3>
            </div>
            <div className="card-body">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex align-items-baseline">
                    <h3 className="card-title">View User</h3>
                  </div>
                  <div className="card-body table-responsive p-0">
                    <table className="table table-hover text-nowrap">
                      <tbody>
                        <>
                          <tr>
                            <th>User</th>
                            <td>{selectedUserData.name}</td>
                          </tr>
                          <tr>
                            <th>Email</th>
                            <td>{selectedUserData.email}</td>
                          </tr>
                          <tr>
                            <th>Mobile Number</th>
                            <td>{selectedUserData.mobile}</td>
                          </tr>
                          <tr>
                            <th>Gender</th>
                            <td>{selectedUserData.gender}</td>
                          </tr>
                          <tr>
                            <th>Date of Birth</th>
                            <td>{selectedUserData.dob}</td>
                          </tr>
                          <tr>
                            <th>Deactivated</th>
                            <td>Activate</td>
                          </tr>
                          <tr>
                            <th>Designation</th>
                            <td>{selectedUserData.designation}</td>
                          </tr>
                          <tr>
                            <th>Permissions</th>
                            <td>{selectedUserData.permissions}</td>
                          </tr>
                          <tr>
                            <th>Emergency Number</th>
                            <td>{selectedUserData.emergencyContact}</td>
                          </tr>
                          <tr>
                            <th>Address</th>
                            <td>{selectedUserData.address}</td>
                          </tr>
                        </>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ViewUser;
